<div class="wt-input wt-input-select-autocomplete">
  <ng-select class="wt-input__input wt-input-select-autocomplete__input"
             [class.wt-input__input--filled]="isFilled"
             [id]="id"
             [items]="items"
             [bindValue]="bindValue"
             [bindLabel]="bindLabel"
             [placeholder]="placeholder"
             [loadingText]="loadingText"
             [notFoundText]="notFoundText"
             [loading]="loading"
             [isOpen]="isOpen"
             [searchable]="!disabled"
             (search)="onSearch($event)"
             (change)="onChange($event)"
             [clearable]="false"
             dropdownPosition="bottom"
  >
  </ng-select>

  <label class="wt-input__label wt-input-select-autocomplete__label"
         *ngIf="label"
         [for]="id"
  >
    {{label}}
  </label>

  <div class="wt-input__error"
       *ngIf="isInvalid"
  >
    {{errorMessage}}
  </div>
</div>

